import type { PlanStrategyType } from '../types';
import type { PlanStrategy } from './type';
import { NAIVE } from './naive';
import { RTB } from './rtb';
import { OOH } from './ooh';

export type { PlanStrategy };

export const strategies: Record<PlanStrategyType, PlanStrategy> = {
  NAIVE,
  RTB,
  OOH,
};

export const strategyLabelMap: Record<PlanStrategyType, string> = Object.keys(strategies).reduce(
  (acc: any, key: any) => {
    acc[key] = strategies[key as PlanStrategyType].TITLE;
    return acc;
  },
  {},
);
